import ApiClient from "../helpers/ApiClient";

const baseClienteEndpoint = (cnpj) => `/empresa/${cnpj}/clientes`;

const listClientes = (cnpj) =>
  ApiClient.apiClientDef.get(baseClienteEndpoint(cnpj));

const getCliente = (cnpj, uid) =>
  ApiClient.apiClientDef.get(`${baseClienteEndpoint(cnpj)}/${uid}`);

const verificaCliente = (cnpj, params) =>
  ApiClient.apiClientDef.get(`${baseClienteEndpoint(cnpj)}/validarDocumento/`, {
    params,
  });

const deleteCliente = (cnpj, uid) =>
  ApiClient.apiClientDef.delete(`${baseClienteEndpoint(cnpj)}/${uid}`);

const putCliente = (cnpj, uid, data) =>
  ApiClient.apiClientDef.put(`${baseClienteEndpoint(cnpj)}/${uid}`, data);

const postCliente = (cnpj, data) =>
  ApiClient.apiClientDef.post(baseClienteEndpoint(cnpj), data);

const ClienteApiClient = {
  listClientes,
  getCliente,
  verificaCliente,
  deleteCliente,
  putCliente,
  postCliente,
};
export default ClienteApiClient;
